import axios, { AxiosResponse } from 'axios'
import { Global } from 'global'
import { autoTopPaddingHelper } from 'helper'
import { useCleanEvents } from 'hooks'
import $ from 'jquery'

import * as Shared from '../shared/index'

import { DependentSelectBoxComponent } from '@/component/dependentSelectBox/dependentSelectBox.component'
import { bootstrapFeedbackGrid } from '@/component/feedbackGrid'
import { bootstrapFieldworkImportDetail } from '@/component/fieldworkImportDetail'
import { TextAnalyticsCategoryComponent } from '@/component/textAnalyticsCategory/textAnalyticsCategory.component'
import { GlobalService } from '@/services'

export const Events = () => {
	const onAjaxComplete = (complete: (payload: any) => void) => {
		document.addEventListener('DOMContentLoaded', () => {
			// @ts-ignore
			$.nette.ext({
				complete: (payload: any) => {
					useCleanEvents()
					GlobalService.registerAppConfig()
					Global.init({ isAjax: true })
					Shared.default().initAll(true)
					autoTopPaddingHelper.calculateTopPaddingFilter()
					DependentSelectBoxComponent.init()
					TextAnalyticsCategoryComponent.init()
					bootstrapFeedbackGrid()
					bootstrapFieldworkImportDetail()
					complete(payload)
				},
			})
			axios.interceptors.response.use(async (response: AxiosResponse) => {
				useCleanEvents()
				GlobalService.registerAppConfig()
				Global.init({ isAjax: true })
				Shared.default().initAll(true)
				autoTopPaddingHelper.calculateTopPaddingFilter()
				DependentSelectBoxComponent.init()
				TextAnalyticsCategoryComponent.init()
				bootstrapFeedbackGrid()
				bootstrapFieldworkImportDetail()
				complete(response)
				return response
			})
		})
	}

	const onBeforeAjaxConfirm = (before: (xhr: any, settings: any) => void) => {
		document.addEventListener('DOMContentLoaded', () => {
			$.nette.ext('confirm', {
				before,
			})
		})
	}

	const onDOMLoad = (listener: () => void) => {
		document.addEventListener('DOMContentLoaded', () => {
			GlobalService.registerAppConfig()
			Global.init({ isAjax: false })
			Shared.default().initAll()
			autoTopPaddingHelper.calculateTopPaddingFilter()
			TextAnalyticsCategoryComponent.init()
			bootstrapFeedbackGrid()
			bootstrapFieldworkImportDetail()
			listener()
		})
	}

	const onLoad = (listener: () => void) => {
		document.addEventListener('load', listener)
	}

	const onNetteExtLoad = (listener: () => void) => {
		document.addEventListener('DOMContentLoaded', () => {
			$.nette.ext('after-load', {
				load: listener,
			})
		})
	}

	const onResizeWindow = (listener: () => void) => {
		let resizeTimer: ReturnType<typeof setTimeout>
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer)
			resizeTimer = setTimeout(() => {
				listener()
			}, 250)
		})
	}

	return {
		onAjaxComplete,
		onBeforeAjaxConfirm,
		onDOMLoad,
		onLoad,
		onNetteExtLoad,
		onResizeWindow,
	}
}
